import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import ReactPlayer from "react-player";

import swal from "sweetalert";
import JudgeMarkForm from "./JudgeMarkForm";
import useVdieoHandleS3 from "../../CustomHooks/useVideoHandleS3";
import { serverInfo } from "../../App";
import MediaUploadProgressBar from "../../Screen/MediaUploadProgressBar";
import useVideoHandleWithCompress from "../../CustomHooks/useVideoHandleWithCompress";

const AuditionLiveVideoUploadModal = (props) => {
  const { setVideoUrl } = props;
  const { assigned_judges } = props.event;
  const { user_uploaded_video } = props.auditionParticipant;
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const user_id = props.userId;
  const [isVideo, setVideo] = useState();

      // video upload s3
      const [fileVideo, setFileVideo] = useState('');
      const [videoDelKey, setVideoDelKey] = useState(null);
      const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(fileVideo, 'audition/videos', videoDelKey);



  useEffect(() => {
    axios
      .get(
        `/api/audition-admin/audition-mark/uploadedVideo/${user_id}/${props?.event?.id}/${props?.event?.active_round_info_id}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
        }
      });
  }, []);

  const handleVideoChange = (file) => {
    // setVideoDelKey(videoKey)
    setFileVideo(file[0]);
  };

  const submitPostMakingContent = (e) => {
    e.preventDefault();
    const fData = new FormData();

    fData.append("audition_id", props.event.id);
    fData.append("user_id", user_id);
    fData.append("round_info_id", props.event.active_round_info_id);
    fData.append("video", videoKey);
      axios
        .post(`/api/audition-admin/audition/uploadLiveUserVideo`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            setVideoUrl(true);
            setFileVideo('')
            swal("Success", res.data.message, "success");
          }
        });
  };

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="AuditionLiveJudge">
          <div className="d-flex justify-content-between mb-3">
            <h3 className="decline-form text-warning fw-bold">Upload Video</h3>

            <i
              className="fa-solid fa-xmark text-warning"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setVideoUrl(true);
                props.onHide();
              }}
            ></i>
          </div>
          <div>
            <form
              onSubmit={submitPostMakingContent}
              id="input_form"
              encType="multipart/form-data"
            >
              {videoUrl ? (
                <>
                  <ReactPlayer
                    url={videoUrl}
                    className="width-img"
                    controls={true}
                  />
                </>
              ) : (
                <></>
              )}
              <input
                type="file"
                accept="video/*"
                className="form-control w-100 custom-in-color "
                onChange={(e) => handleVideoChange(e.target.files)}
              />
               {fileVideo && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
              <div className="decline-btns d-flex justify-content-end">
                <div>
                  <button
                    onClick={props.onHide}
                    className="btn btn-warning mx-2 px-4"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AuditionLiveVideoUploadModal;
